@if (value) {
  @if (value.is_set || (uploadedFile && !component?.id)) {
    <div class="uploaded-document-wrapper" [ngStyle]="formats?.style">
      <input class="file-text" disabled [matTooltip]="value.filename || uploadedFile.name"
        matTooltipClass="full-value-tooltip"
        [matTooltipShowDelay]="tooltipShowDelay" value="{{value.filename || uploadedFile.name}}">
      <div class="button-container">
        @if (component?.id) {
          <button (click)="downloadFile(value)" mat-fab color="warn" class="button"
            [matTooltip]="may_download ? 'Download file.' : 'You\'re not authorised to download file attachments.'"
            [disabled]="!may_download">
            <mat-icon>download</mat-icon>
          </button>
        }
        <button
          (click)="openConfirmWindow()" mat-fab color="warn" class="button"
          [matTooltip]="may_delete ? 'Delete file.' : 'You\'re not authorised to delete file attachments.'"
          [disabled]="!may_delete">
          <div class="fa fa-trash"></div>
        </button>
      </div>
    </div>
  } @else {
    <div class="upload-button-container" [ngStyle]="formats?.style">
      <button
        class="file-upload-button"
        mat-button (click)="selectFile()"
        [matTooltip]="may_upload ? 'Upload file.' : 'You\'re not authorised to upload file attachments.'"
        [disabled]="!may_upload"
        [innerHTML]="highlightQuotedText(value.error) || defaultPlaceholder"
        >
      </button>
    </div>
  }
}
